<template>
  <div class="index">
    <div class="top-panel" ref="bar">

      <Carousel class="top" loop ref="index">
        <CarouselItem>
            <div class="top_carouselItem">
              <img src="/static/image/banner/banner_home.png" />
            </div>
        </CarouselItem>
      </Carousel>

      <div class="cpzx" ref="cpzx">
        <div class="title">产品中心</div>
        <div class="desc">PRODUCT CENTER</div>
        <div class="content">
          <div class="bg1" @click="pushView(3, 0)">
            <img src="/static/image/home/home_img1_product.png" class="img1 " />

            <img  src="/static/image/home_btn_more@2x.png" class="btn-img content_item" />
          </div>
          <div class="bg2" @click="pushView(3, 1)">
            <img src="/static/image/home_img3_product@2x.png" class="img1 " />

            <img  src="/static/image/home_btn_more@2x.png" class="btn-img content_item" />
          </div>
          <div class="bg3" @click="pushView(3, 2)">
            <img src="/static/image/home_img2_product@2x.png" class="img1" />

            <img src="/static/image/home_btn_more@2x.png" class="btn-img content_item" />
          </div>
        </div>
      </div>
      <div class="hxjs" ref="hxjs">
        <div class="title">核心技术</div>
        <div class="desc">CORE TECHNOLOGY</div>
        <div class="middle">
          <div class="item">
            <img src="/static/image/home_icon1_technology@2x.png" />
            <div class="name">慧影影像平台</div>
          </div>
          <div class="item">
            <img src="/static/image/home_icon2_technology@2x.png" />
            <div class="name">慧影色彩管理平台</div>
          </div>
          <div class="item">
            <img src="/static/image/home_icon3_technology@2x.png" />
            <div class="name">慧影智能互联平台</div>
          </div>
          <div class="item">
            <img src="/static/image/home_icon4_technology@2x.png" />
            <div class="name">慧影手术导航平台</div>
          </div>
          <div class="item">
            <img src="/static/image/home_icon5_technology@2x.png" />
            <div class="name">慧影计算及硬件平台</div>
          </div>
        </div>
        <div class="tabs">
          <div class="item">
            <div class="name">全链路</div>
            <div class="value">自主原研</div>
          </div>
          <div class="item c">
            <div class="name">3<span>张</span></div>
            <div class="value">NMPA注册证</div>
          </div>
          <div class="item">
            <div class="name">20<span>+</span></div>
            <div class="value">知识产权</div>
          </div>
          <div class="item c">
            <div class="name">100<span>+</span></div>
            <div class="value">医院装机/试用</div>
          </div>
        </div>
        <div class="info" @click="pushView(2, 0)">
          <img src="/static/image/home_btn_more@2x.png" class="btn-img content_item"/>
        </div>
      </div>
      <div class="news" ref="news">
        <div class="title">新闻中心</div>
        <div class="desc">NEWS CENTER</div>
        <div class="picture">
          <div class="pic">
            <img src="/static/image/home_img_news@2x.png" class="picImg" />
            <div class="title_1">公司新闻</div>
            <div class="title_2">
              晨新医疗以质量为基石，创新为航标，坚守对卓越品质与前沿技术的追求
            </div>
            <img
              src="/static/image/home_btn_more@2x.png"

              class="image btn-img content_item"
              @click="pushView(4, 0)"
            />
          </div>

        </div>
        <div class="cards">
          <div class="card content_item" v-for="(item, index) in news" :key="index" @click="openWeiChatView(item)">
            <div class="time-p">
              <div class="time">
                <div class="day">
                  {{ item.day }}
                </div>
                <div class="year">
                  <div class="name">{{ item.month }}月</div>
                  <div class="name">{{ item.year }}</div>
                </div>
              </div>
              <div class="label">{{ item.type }}</div>
            </div>
            <div class="value">{{ item.title }}</div>
          </div>
        </div>
      </div>
      <div class="gywm" ref="gywm">
        <div class="title">关于晨新</div>
        <div class="desc">ABOUT US</div>
        <div class="content">
          <div class="left">
            <img src="/static/image/home_slogan_aboutus@2x.png" class="icon " />
            <div class="label">
              晨新医疗成立于2022年10月，是一家以创新为驱动，致力于4K+荧光+3D内窥镜成像设备的产品研发、生产、商业化的科技型企业。公司凭借强大的研发能力立足于国产医疗设备创新的前沿，实现国产化设备从“看的清-看的准-看的真”的跨越式发展。<br>
              研发团队实力雄厚，产品优势显现，专家+市场+资本认可度攀升，产品覆盖泌尿、肝胆、心胸、普外、妇科等七个科室。晨新全面布局精准医疗、微创医疗市场，力争成为内窥镜成像设备领域第一家科创板上市企业，为微创手术的普及和提升做出自己的贡献。
            </div>
            <div class="more " @click="pushView(1, 0)">
              <img class="content_item" src="/static/image/home_btn_more@2x.png" />

            </div>
          </div>
          <div class="right">
            <img class="t_image" src="/static/image/aboutus_img1@2x.png" />
          </div>
        </div>
      </div>
      <Footer></Footer>
    </div>
  </div>
</template>
<script>
import Footer from "@/components/Footer.vue";
import {
  listNews,
} from "@/api/news";
import { mapState, mapMutations } from "vuex";
export default {
  components: {
    Footer,
  },
  created() {
      this.changeHeaderIndex(0);

    },
  data() {
    return {
      queryParams: {
        pageNum: 1,
        pageSize: 3,
        name: undefined,
        beginTime: undefined,
        endTime: undefined,
      },
      rows: [],
      news: [
        {
          day: "02",
          month: "01月",
          year: "2024",
          type: "晨新动态",
          content: "晨新医疗2023年度大事记 | 永远相信美好的事情即将发生",
        },

        {
          day: "30",
          month: "12月",
          year: "2023",
          type: "行业资讯",
          content: "​晨新医疗 | 4K荧光内窥镜摄像系统为医生打造一双“慧眼”",
        },
        {
          day: "02",
          month: "01月",
          year: "2024",
          type: "会议预告",
          content:
            "会议预告 | 第十届中国（武汉）国际微创外科大会暨湖北省医学会腹腔镜外科分会年会",
        },
      ],
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    ...mapMutations([
      "changeHeaderIndex",
      "changeaboutPageCurrentSelected",
      "changehxjsPageCurrentSelected",
      "changecpzxPageCurrentSelected",
      "changejoinusPageCurrentSelected",
    ]),
    pushView(type, selectedNuber) {
      window.localStorage.setItem("index", type);
      this.changeHeaderIndex(type);

      switch (type) {
        case 1:
          {
            this.changeaboutPageCurrentSelected(selectedNuber);
            this.$router.push({
              name: "aboutCnew",
              params: {
                selectedNuber: selectedNuber,
              },
            });
          }

          break;
        case 2:
          {
            this.changehxjsPageCurrentSelected(selectedNuber);
            this.$router.push({
              name: "coreTechnology",
              params: {
                selectedNuber: selectedNuber,
              },
            });
          }
          break;
        case 3:
          {
            this.changecpzxPageCurrentSelected(selectedNuber);
            if(selectedNuber == 0){
              this.$router.push({
              name: "programme",
              params: {
                selectedNuber: selectedNuber,
              },
            });
            }else  if(selectedNuber == 1){
              this.$router.push({
              name: "pad",
              params: {
                selectedNuber: selectedNuber,
              },
            });
            }else  if(selectedNuber == 2){
              this.$router.push({
              name: "operatingRoom",
              params: {
                selectedNuber: selectedNuber,
              },
            });
            }

          }
          break;
          case 4:
          {
            this.changehxjsPageCurrentSelected(selectedNuber);
            this.$router.push({
              name: "news",
              params: {
                selectedNuber: selectedNuber,
              },
            });
          }
          break;
        case 6:
          {
            this.changejoinusPageCurrentSelected(item.selectedNuber);
          }
          break;
        default:
          break;
      }
    },
        // 查询列表
     getList() {

      listNews(this.queryParams).then((response) => {
        this.news = response.rows;
        this.news.forEach(item =>{

          var dateString = item.date.split(" ")[0]; // 输入的日期字符串
          var parts = dateString.split("-"); // 使用"-"作为分隔符对字符串进行切割
          var year = parts[0]; // 获取年份部分
          var month = parts[1]; // 获取月份部分
          var day = parts[2]; //

          item.year= year;
          item.month = month;
          item.day = day;
        });
      });
    },
    openWeiChatView(item){
      window.open(item.url,"_blank")

    }
  },
};
</script>
<style lang="scss" scoped>
.index {
  width: 100%;
  height: 100%;
  position: relative;
  .top-panel {
    .top {
      height: 930px;
      background: white;

    .top_carouselItem{
      width: 100%;
      height: 930px;

      img{

        width: 1920px;
        height: 930px;
      }
    }
    }
    .gywm {
      height: 450px;
      background: white;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 0px 0px 78px 0px;
      .title {
        width: 128px;
        height: 45px;
        font-size: 32px;
        font-family: Microsoft YaHei, Microsoft YaHei;
        font-weight: bold;
        color: #333333;
      }
      .desc {
        height: 33px;
        font-size: 24px;
        font-family: Microsoft YaHei, Microsoft YaHei;
        font-weight: bold;
        line-height: 20px;
        color: #d6d6d6;
      }
      .content {
        width: 1209px;
        display: flex;
        .left {
          display: flex;
          width: 657px;
          align-items: center;
          margin-top: 74px;
          flex-direction: column;
          .icon {
            width: 350px;
            height: 58px;
          }
          .label {
            width: 100%;
            font-size: 16px;
            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: 400;
            color: #333333;
            line-height: 26px;
            margin-top: 32px;
          }
          .more {
            width: 100%;
            img {
              width: 160px;
              margin-left: 24px;
              margin-top: 26px;
              height: 36px;
              border-radius: 18px;
              cursor: pointer;
            }
          }
        }
        .right {
          display: flex;
          margin: 40px 0px 0px 70px;
          img {
            width: 482px;
            height: 348px;
          }
        }
      }
    }
    .cpzx {
      height: 497px;
      display: flex;
      flex-direction: column;
      padding: 51px 0px 85px 0px;
      align-items: center;
      // background: url("/static/image/home_bg_product@2x.png") 100% 100%
        // no-repeat;
      .title {
        width: 128px;
        height: 45px;
        font-size: 32px;
        font-family: Microsoft YaHei, Microsoft YaHei;
        font-weight: bold;
        color: #333333;
      }
      .desc {
        height: 33px;
        font-size: 24px;
        font-family: Microsoft YaHei, Microsoft YaHei;
        font-weight: bold;
        color: #d6d6d6;
      }
      .content {
        display: flex;
        width: 1172px;
        margin-top: 47px;
        .bg1 {
          width: 384px;
          height: 260px;
          position: relative;
        }
        .bg2 {
          width: 384px;
          height: 260px;
          margin-left: 20px;
          position: relative;
        }
        .bg3 {
          width: 384px;
          height: 260px;
          margin-left: 20px;
          position: relative;
        }
        .title {
          position: absolute;
          left: 35px;
          height: 30px;
          width: 100%;
          bottom: 82px;
          font-size: 24px;
          font-family: Microsoft YaHei, Microsoft YaHei;
          font-weight: bold;
          color: #ffffff;
        }

        .img1 {
          position: absolute;
          left: 0px;
          width: 384px;
          height: 260px;
          top: 0px;
        }
        .btn-img {
          position: absolute;
          left: 200px;
          width: 160px;
          height: 36px;
          bottom: 21px;
          border-radius: 18px;
          cursor: pointer;
        }
      }
    }
    .hxjs {
      display: flex;
      height: 750px;
      background: #F6F6F6;
      flex-direction: column;
      align-items: center;
      padding: 40px 0px 0px 0px;
      .title {
        width: 128px;
        height: 45px;
        font-size: 32px;
        font-family: Microsoft YaHei, Microsoft YaHei;
        font-weight: bold;
        color: #333333;
      }
      .desc {
        height: 33px;
        font-size: 24px;
        line-height: 20px;
        font-family: Microsoft YaHei, Microsoft YaHei;
        font-weight: bold;
        color: #D6D6D6;
      }
      .middle {
        width: 1008px;
        display: flex;
        margin-top: 57px;
        justify-content: space-between;
        .item {
          display: flex;
          width: 180px;
          flex-direction: column;
          align-items: center;
          img {
            width: 132px;
            height: 132px;
          }
          .name {
            margin-top: 21px;
            font-size: 20px;
            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: bold;
            color: #333333;
          }
        }
      }
      .tabs {
        width: 1200px;
        display: flex;
        margin-top: 99px;
        .item {
          display: flex;
          flex: 1;
          height: 142px;
          padding: 30px 0px 36px;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          background: rgba(0, 71, 158, 0.8);
          .name {
            height: 37px;
            font-size: 28px;
            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: 400;
            color: #ffffff;
            span {
              height: 19px;
              font-size: 14px;
              font-family: Microsoft YaHei, Microsoft YaHei;
              font-weight: 400;
              margin-left: 7px;
              color: #ffffff;
            }
          }
          .value {
            margin-top: 15px;
            font-size: 18px;
            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: 400;
            color: #ffffff;
          }
        }
        .c {
          background: rgba(4, 175, 122, 0.8);
        }
      }
      .info {
        display: flex;
        width: 1200px;
        margin-top:48px;
        justify-content: flex-end;
        img {
          width: 160px;
          height: 36px;
          cursor: pointer;
        }
      }
    }
    .news {
      height: 722px;
      display: flex;
      align-items: center;
      background: white;
      flex-direction: column;
      padding: 48px 0px 21px 0px;
      .title {
        width: 128px;
        height: 45px;
        font-size: 32px;
        font-family: Microsoft YaHei, Microsoft YaHei;
        font-weight: bold;
        color: #333333;
      }
      .desc {
        height: 33px;
        font-size: 24px;
        font-family: Microsoft YaHei, Microsoft YaHei;
        font-weight: bold;
        line-height: 20px;
        color: #d6d6d6;
      }
      .picture {
        width: 1200px;
        display: flex;
        margin: 40px 0px 24px 0px;
        justify-content: space-between;
        .pic {
          position: relative;
          width: 1200px;
          height: 320px;
          .picImg {
            position: absolute;
            top: 0px;
            left: 0px;
            width: 1200px;
            height: 320px;
          }
          .image {
            position: absolute;
            right: 21px;
            bottom: 20px;
            width: 160px;
            height: 36px;
            border-radius: 18px;
            cursor: pointer;
          }
          .title_1 {
            position: absolute;
            left: 14px;
            height: 28px;
            width: 100%;
            bottom: 57px;
            font-size: 20px;
            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: bold;
            color: #333333;
          }
          .title_2 {
            position: absolute;
            left: 14px;
            height: 28px;
            width: 100%;
            bottom: 20px;
            font-size: 16px;
            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: 400;
            color: #333333;
          }
        }
        .gif {
          width: 384px;
          background: #ffffff;
          border: 1px solid #707070;
          height: 320px;
        }
      }
      .cards {
        width: 1200px;
        display: flex;
        justify-content: space-between;
        .card {
          width: 384px;
          height: 140px;
          padding: 10px 16px 22px 16px;
          display: flex;
          flex-direction: column;
          background: #ffffff;
          cursor: pointer;
          box-shadow: 0px 0px 10px 1px rgba(0, 0, 0, 0.1);

          .time-p {
            display: flex;
            justify-content: space-between;

            .time {
              display: flex;
              .day {
                width: 54px;
                height: 63px;
                font-size: 46px;
                font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
                font-weight: bold;
                color: #333333;
              }
              .year {
                display: flex;
                align-items: center;
                margin-left: 7px;
                margin-top: 18px;
                flex-direction: column;
                .name {
                  width: 32px;
                  font-size: 14px;
                  line-height: 18px;
                  font-family: Microsoft YaHei, Microsoft YaHei;
                  font-weight: 400;
                  color: #333333;
                }
              }
            }

            .label {
              font-size: 14px;
              margin-top: 35px;
              font-family: Microsoft YaHei, Microsoft YaHei;
              font-weight: 400;
              color: #999999;
            }
          }
          .value {
            font-size: 16px;
            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: 400;
            margin-top: 6px;
            color: #333333;
            line-height: 24px;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/index/index.vue